import axios from "axios";
import { useSelector } from "react-redux";
import { store } from "redux/store";
import { toast } from "react-toastify";
import RenderInlineNotification from "components/RenderInlineNotification";
import { toastTips } from "./tools";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const PREFIX_URL = process.env.REACT_APP_API_PREFIX;

const serviceAxios = axios.create({
  baseURL: BASE_URL + PREFIX_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

serviceAxios.interceptors.request.use(
  (config) => {
    // Do something before request is sent
    if (
      typeof config.data === "string" &&
      config.headers["Content-Type"] !== "multipart/form-data" &&
      config.headers["Content-Type"] !== "application/json "
    ) {
      config.data = JSON.stringify(config.data);
    }

    // Get user info from the Redux store
    const state = store.getState();
    const userInfo = state.user;

    if (userInfo) {
      config.headers["x-user-role"] = userInfo.role || "";
      config.headers["x-user-name"] = userInfo.name || "";
      config.headers["x-user-email"] = userInfo.email || "";
      config.headers["x-user-id"] = userInfo.id || "";
      config.headers["x-user-app-user-uuid"] = userInfo.app_user_uuid || "";
      config.headers["x-user-zendesk-subdomain"] = userInfo.zendesk_subdomain || "";
    }

    return config;
  },
  (error) => {
    // Do something with request error
    return Promise.reject(error);
  },
);
serviceAxios.interceptors.response.use(
  (response) => {
    // Do something before response is sent
    switch (response.status) {
      case 200:
        return response.data;
      case 400:
        return response.data;
      case 401:
        return response.data;
      case 403:
        toastTips("User doesn't have access", "error");
        break;
      case 404:
        return response.data;
      case 500:
        toastTips(data.message, "error");
        break;
      default:
        return response.data;
    }
  },
  (error) => {
    console.log(error);
    const { response } = error;
    const { status = "", data } = response;
    switch (status) {
      case 400:
        if (response.data.message.length > 0) {
          toastTips(response.data.message, "error");
        } else {
          toastTips("error", "error");
        }
        return response;
      // break;
      case 401:
        toastTips("Unauthorized user", "error");
        break;
      case 403:
        toastTips("User doesn't have access", "error");
        break;
      case 404:
        toastTips(data.message, "error");
        break;
      case 500:
        toastTips(data.message, "error");
        break;
      default:
        toastTips(data.message, "error");
        break;
    }
    // console.log(error);
    // Do something with response error
    return Promise.reject(error);
  },
);
export default serviceAxios;
